/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyBarricade = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path fill="#E2E4EA" d="m122.554 49.565-102.02-2.827v28.925l102.02-6.905z" />
    <path
      fill="#CBCFD8"
      d="M23.073 75.464 16.146 46.61l9.159.271 12.39 27.626zM54.45 73.352 41.272 47.315l8.931.249 19.485 24.791zM80.902 71.525l-9.799-23.398 8.931.25 16.106 22.15zM105.286 69.909 93.821 48.764l8.985.255 16.764 19.925z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="m80.15 71.524 28.625-1.887M28.157 46.953l39.649 1.078" />
    <path fill="#E2E4EA" d="m20.533 100.942 102.021 2.669v-29.12L20.533 81.49z" />
    <path
      fill="#CBCFD8"
      d="m33.129 101.28-4.621-20.348 9.659-.666 10.39 21.409zM61.25 102.024l-6.236-22.905 10.946-.731 16.573 24.177zM99.695 102.949 81.46 77.313l10.946-.731 25.27 26.901zM130.076 100.859l-18.234-25.635 10.946-.732 6.188 11.712z"
    />
    <path
      fill="#E2E4EA"
      d="M122.554 45.206c0-.864.7-1.564 1.563-1.564h6.744c.824 0 1.507.64 1.56 1.462l4.828 73.846a1.563 1.563 0 0 1-1.56 1.665h-11.572c-.863 0-1.563-.7-1.563-1.563z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="M122.329 111.177v-15.71M47.5 101.5l19.832.461" />
    <path
      fill="#E2E4EA"
      d="M10.72 45.164a1.564 1.564 0 0 1 1.563-1.522h6.74c.842 0 1.533.668 1.562 1.51l2.559 73.846a1.563 1.563 0 0 1-1.563 1.617H10.304c-.88 0-1.586-.726-1.563-1.605z"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      d="M8.802 116.934v2.313c.06.481.582 1.415 2.176 1.306M21.363 64.6l.85 27.038"
    />
    <ellipse cx={127.098} cy={29.209} fill="#89909F" rx={6.985} ry={9.824} />
    <ellipse cx={15.646} cy={33.023} fill="#89909F" rx={12.861} ry={6.009} />
    <path stroke="#1E2024" strokeLinecap="round" d="M3.223 34.735c-.81-1.149-1.398-3.897 2.727-5.702" />
    <rect width={13.361} height={4.61} x={120.723} y={39.032} fill="#CBCFD8" rx={1.564} />
    <path stroke="#1E2024" strokeLinecap="round" d="M127.383 39.03c1.623-.247 5.084-1.64 5.94-5.24" />
    <rect width={13.361} height={4.61} x={8.967} y={39.032} fill="#CBCFD8" rx={1.564} />
  </svg>
);
export default LegacyEmptyBarricade;
